import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MapItemComponent } from '@ui/shared/util-map';
import { DetailViewModule } from '@ui/shared/ui-detail-view';
import type { ProjectListItemModel } from '../../definitions/project-list-item.model';

@Component({
    selector: 'ui-project-list-item-popup-content',
    imports: [DetailViewModule],
    templateUrl: './project-list-item-popup-content.component.html',
    styleUrl: './project-list-item-popup-content.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectListItemPopupContentComponent implements MapItemComponent<ProjectListItemModel> {
    public mapItem = input<ProjectListItemModel | undefined>();
}
